function onAuthflowCookiesDidSet(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onAuthflowCookiesDidSet', e);
  }

  // Do something stub onAuthflowCookiesDidSet

  return;
}

export default onAuthflowCookiesDidSet;
